var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectSellerList',{attrs:{"project":_vm.project},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }